import { Descriptions } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";

function Info() {
  const { activeObjCatPartners, activeObjPartners } = useSelector((state) => ({
    activeObjCatPartners: state.obj.activeObj["partners-category"],
    activeObjPartners: state.obj.activeObj["partners"],
  }));
  const items1 = [
    {
      key: "1",
      label: "Provider Name",
      children: activeObjPartners?.mipName ?? "N/A",
    },
    {
      key: "5",
      label: "Insititution Type",
      children: activeObjCatPartners?.type?? "N/A",
    },
    {
      key: "3",
      label: "County",
      children: activeObjPartners?.mipCountyName?? "N/A",
    },
    {
      key: "4",
      label: "SubCounty",
      children: activeObjPartners?.mipSubCountyName?? "N/A",
    },
    {
      key: "6",
      label: "Location",
      children: activeObjPartners?.mipLocationName?? "N/A",
    },
    {
      key: "2",
      label: "Date Created",
      children: (
        <div>
          {activeObjPartners?.createdDate
            ? moment(activeObjPartners?.createdDate)?.format(
                "DD-MM-YYYY"
              )
            : "--"}
        </div>
      ),
    },
  ];

  const items2 = [
    {
      key: "1",
      label: "Name",
      children: activeObjPartners?.mipContactPerson ?? "N/A",
    },
    {
      key: "5",
      label: "ID Number",
      children: activeObjPartners?.mipContactIdNumber ?? "N/A",
    },
    {
      key: "2",
      label: "Email",
      children: activeObjPartners?.mipContactEmail ?? "N/A",
    },
  ];
  return (
    <div>
      <div className="w-full flex">
        <Descriptions
          title="MISP Details"
          column={1}
          colon={false}
          items={items1}
        />

        <Descriptions
          title="Contact Person"
          column={1}
          colon={false}
          items={items2}
        />
      </div>
    </div>
  );
}

export default Info;
